import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SearchBar from './SearchBar';
import './MobileSearchModal.css';

interface MobileSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileSearchModal: React.FC<MobileSearchModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIsAnimating(true);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div className={`mobile-search-modal ${isAnimating ? 'open' : 'closing'}`}>
      <div className="modal-backdrop" onClick={handleClose} />
      <div className="modal-content">
        <div className="modal-header">
          <h2>{t('searchBar.searchProducts')}</h2>
          <button 
            className="close-button"
            onClick={handleClose}
            aria-label={t('searchBar.closeSearch')}
          >
            <XMarkIcon className="close-icon" />
          </button>
        </div>
        <div className="modal-body">
          <SearchBar onClose={handleClose} isMobile={true} />
        </div>
      </div>
    </div>
  );
};

export default MobileSearchModal;
